export class StampsObjectivesCantBeLowerThanOriginalException {}